import React from 'react';
import EventsList from './EventsList.jsx';
import {getFormattedDate} from '../calendarHelper.js';
import './EventDisplay.css';

export default class FutureEvents extends React.PureComponent {
  render() {
    const {eventsByTime, eventDate, lastEvent, singleTeamView} = this.props;
    const times = Object.keys(eventsByTime).sort();
    return (
      <div>
        <header className="SectionHeader text-start p-3">
          <span className='text-nowrap'>
          <i className="fa-regular fa-calendar-check me-2"></i>
            {getFormattedDate(eventDate)}
          </span>
          <div className="EventDate EventDate--latest d-inline d-md-block d-lg-inline text-center ">
            {lastEvent ? <span className='text-nowrap'>( Latest Event )</span> : null}</div>
        </header>
        <div className="SectionBodyWrapper">
          <div className="row">
            <div className="col">
              {
                !!eventsByTime ? times.map((time, idx) => (
                    <EventsList
                      singleTeamView={singleTeamView}
                      eventDate={eventDate}
                      eventsAtTime={eventsByTime[time]}
                      time={time}
                      key={`event-${idx}`}
                    />
                  )) :null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
